import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Login from "./components/Login";
import Invite from "./components/Invite";
import './index.css';
import Visitor from "./components/PR";
import Logbook from "./components/logbook";
import AddressBook from "./components/AddressBook";
import UserManagement from "./components/users";
import QRScanner from "./components/Kiosk";
import VisitDetails from "./components/VisitDetails"; 
import ManageEmployees from './components/ManageEmployess';


function App() {
  return (
    <Router>
      <Routes>
        {/* Redirect root (/) directly to /dashboard */}
        <Route path="/" element={<Login />} />
        <Route path="/invite" element={<Invite />} />
        <Route path="/adbook" element={<AddressBook />} />
        <Route path="/log" element={<Logbook />} />
        <Route path="/user" element={<UserManagement />} />
        <Route path="/employees" element={<ManageEmployees />} />

        {/* <Route path="/kiosk" element={<QRScanner />} /> */}
        <Route path="/api/visits/:visitId" element={<Visitor />} />
        <Route path="/visit/:visitId" element={<VisitDetails />} />
      </Routes>
    </Router>
  );
}

export default App;